import { useEffect, useState } from "react";
import Logo from "./Logo";
import { BRAND, CONTACT, scrollToId, waLink } from "../data/site";
import { MessageCircle } from "lucide-react";

const LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "why-us", label: "Why Us" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-cream/85 backdrop-blur-xl border-b border-gold-faint py-3" : "py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-home-button"
          onClick={() => scrollToId("hero")}
          className="flex items-center gap-3 text-left"
        >
          <Logo className="h-9 w-9" />
          <span className="leading-tight">
            <span className="block font-serif text-lg font-semibold tracking-wide">VAYU</span>
            <span className="block text-[10px] uppercase tracking-[0.3em] text-gold-dark">
              Celebrations
            </span>
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollToId(l.id)}
              className="text-xs uppercase tracking-[0.25em] text-clay transition-colors hover:text-gold-dark"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-whatsapp-cta"
          href={waLink(`Hello ${BRAND.name}! I'd like to plan an event.`)}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 rounded-full bg-night px-5 py-2.5 text-xs uppercase tracking-[0.2em] text-cream transition-all hover:bg-gold-dark hover:text-night"
        >
          <MessageCircle className="h-4 w-4 transition-transform group-hover:-rotate-12" />
          <span className="hidden sm:inline">{CONTACT.whatsappDisplay}</span>
          <span className="sm:hidden">Chat</span>
        </a>
      </div>
    </header>
  );
}
